import { useState } from "react";
import { FileText, ChevronDown } from "lucide-react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ExportOrdersData } from "../../../api-handle/orderApi";

const ExportDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleExport = async (type) => {
        try {
            const res = await ExportOrdersData();
            if (type === "excel") exportToExcel(res.data);
            else if (type === "pdf") exportToPDF(res.data);
            setIsOpen(false);
        } catch (error) {
            console.error("Error exporting orders:", error);
        }
    };

    const exportToExcel = (orders) => {
        const data = orders.map(order => {
            const itemsString = order.items.map(item => {
                return `${item.productName} x${item.quantity} - ${item.productDescription}`;
            }).join("; ");


            return {
                OrderID: order.uniqueId,
                Customer: order.customer,
                Email: order.email,
                Phone: order.phone,
                Status: order.status,
                PaymentStatus: order.paymentStatus,
                Products: itemsString,
                Total: order.total,
                CreatedAt: new Date(order.createdAt).toLocaleString(),
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(data);

        // 👇 Define column widths (in character units)
        worksheet['!cols'] = [
            { wch: 30 }, // OrderID
            { wch: 20 }, // Customer
            { wch: 25 }, // Email
            { wch: 18 }, // Phone
            { wch: 12 }, // Status
            { wch: 15 }, // PaymentStatus
            { wch: 50 }, // Products
            { wch: 10 }, // Total
            { wch: 22 }, // CreatedAt
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Orders.xlsx");
    };



    const exportToPDF = (orders) => {
        const doc = new jsPDF();
        const primaryColor = "#33bdbf";

        doc.setFontSize(18);
        doc.setTextColor(primaryColor);
        doc.text("FitFind - Orders Report", 14, 20);
        doc.setTextColor("#000");
        doc.setFontSize(12);

        let y = 30;

        orders.forEach((order, index) => {
            if (y > 270) {
                doc.addPage();
                y = 20;
            }

            // Items formatted in one string
            const items = order.items.map((item, idx) =>
                `${idx + 1}. ${item.productName} (Qty: ${item.quantity})`
            ).join("\n");

            doc.setFillColor("#f5f5f5");
            doc.roundedRect(14, y, 180, 40, 4, 4, "F");

            doc.setTextColor(primaryColor);
            doc.text(`Order ID: ${order.uniqueId}`, 18, y + 6);
            doc.setTextColor("#000");
            doc.text(`Customer: ${order.customer}`, 18, y + 14);
            doc.text(`Email: ${order.email}`, 18, y + 20);
            doc.text(`Phone: ${order.phone}`, 18, y + 26);
            doc.text(`Total: $${order.total}`, 140, y + 14);
            doc.text(`Status: ${order.status}`, 140, y + 20);
            doc.text(`Payment: ${order.paymentStatus}`, 140, y + 26);
            doc.text(`Date: ${new Date(order.createdAt).toLocaleString()}`, 18, y + 32);

            doc.setFontSize(11);
            doc.text("Items:", 18, y + 38);
            doc.setFontSize(10);
            doc.text(items, 34, y + 38);

            y += 50;
        });

        doc.save("Orders.pdf");
    };

    return (
        <div style={{ position: "relative", display: "inline-block" }}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                    backgroundColor: "#33bdbf",
                    color: "#fff",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                }}
            >
                <FileText size={18} />
                Export Orders
                <ChevronDown size={16} />
            </button>

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        marginTop: "8px",
                        backgroundColor: "#fff",
                        border: "1px solid #e5e5e5",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        zIndex: 10,
                        width: "180px"
                    }}
                >
                    <button
                        onClick={() => handleExport("excel")}
                        style={{
                            width: "100%",
                            padding: "10px 16px",
                            textAlign: "left",
                            background: "none",
                            border: "none",
                            color: "#000",
                            cursor: "pointer",
                            fontSize: "14px",
                        }}
                        onMouseOver={e => e.target.style.backgroundColor = "#f5f5f5"}
                        onMouseOut={e => e.target.style.backgroundColor = "transparent"}
                    >
                        Export as Excel
                    </button>
                    <button
                        onClick={() => handleExport("pdf")}
                        style={{
                            width: "100%",
                            padding: "10px 16px",
                            textAlign: "left",
                            background: "none",
                            border: "none",
                            color: "#000",
                            cursor: "pointer",
                            fontSize: "14px",
                        }}
                        onMouseOver={e => e.target.style.backgroundColor = "#f5f5f5"}
                        onMouseOut={e => e.target.style.backgroundColor = "transparent"}
                    >
                        Export as PDF
                    </button>
                </div>
            )}
        </div>
    );
};

export default ExportDropdown;
